import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("普通管理员")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("超级管理员")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("启用")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("禁用")
const _hoisted_5 = { class: "tree" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取 消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确认")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_tree = _resolveComponent("el-tree")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_el_dialog, {
      width: "500px",
      title: _ctx.prop.title,
      modelValue: _ctx.prop.visible,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.prop.visible = $event)),
      "close-on-click-modal": false,
      onClose: _ctx.handleCloseDialog
    }, {
      footer: _withCtx(() => [
        _createVNode("span", _hoisted_6, [
          _createVNode(_component_el_button, { onClick: _ctx.handleCloseDialog }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _ctx.submitData
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.formData,
          rules: _ctx.rules,
          "label-width": "80px",
          ref: "formRef"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: '角色名',
              prop: "roleName"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.roleName,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.formData.roleName = $event)),
                  type: "text",
                  maxlength: "16",
                  placeholder: '请输入',
                  style: {"width":"200px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: '类型',
              prop: "roleType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.roleType,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.formData.roleType = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 2 }, {
                      default: _withCtx(() => [
                        _hoisted_1
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: '状态',
              prop: "roleStatus"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.formData.roleStatus,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.formData.roleStatus = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: 1 }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: 0 }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: '说明',
              prop: "remark"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.formData.remark,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.formData.remark = $event)),
                  type: "text",
                  placeholder: '请输入',
                  style: {"width":"200px"}
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { prop: "treeList" }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_5, [
                  _createVNode(_component_el_tree, {
                    ref: "tree",
                    modelValue: _ctx.formData.treeList,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.formData.treeList = $event)),
                    "node-key": "name",
                    props: _ctx.treeProps,
                    "show-checkbox": "",
                    data: _ctx.treeList,
                    "default-checked-keys": _ctx.keys,
                    onCheck: _ctx.handleTreeCheck
                  }, null, 8, ["modelValue", "props", "data", "default-checked-keys", "onCheck"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onClose"])
  ]))
}